import { createDynamicThunk } from ".";

/**
 * LIST Deleted Audits
 */
export const fetchDeletedAuditsThunk = createDynamicThunk({
  typePrefix: "deletedAudits/fetchDeletedAuditsThunk",
  useHandleSearch: true,
});

export const getDeletedAuditDetailThunk = createDynamicThunk({
  typePrefix: "audits/getDeletedAuditDetailThunk",
  endpoint: "/audits",
  method: "GET",
});